import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { DepositModalComponent } from '@features/wallet/deposit/modals/deposit-modal/deposit-modal.component';

export function provideDepositModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'DepositModal', component: DepositModalComponent, requiresAuth: true }, multi: true },
  ];
}
